// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  font-family: \"Roboto\", serif;\n  font-size: 22px;\n}\n#app {\n  background-size: cover;\n  background-position: center center;\n}\n.v-application--wrap {\n  min-width: 100vw !important;\n}\n.content {\n  padding: 0 !important;\n}\n.app-bar {\n  padding: 20px 10%;\n}\n@media (max-width: 960px) {\n.content {\n    padding-top: 54px !important;\n}\n}", ""]);
// Exports
module.exports = exports;
